@if (capability$ | async; as capability) {
  <elder-basic-pane-layout class="full">
    <elder-pane class="flex-25 outlined">
      <elder-pane-header>
        <elder-pane-subtitle start>{{ 'skillSets.skillSets' | translate }}</elder-pane-subtitle>
      </elder-pane-header>
      <elder-pane-content>
        <elder-table
          class="flex"
          [data]="skillSets$ | async"
          [idField]=""
          [elderTableActivation]="{ autoActivation: 'always', autoActivateItem: 'first' }"
          [activeItem]="selectedSkillSet()"
          (activeItemChange)="selectedSkillSet.set($event)"
          [selectionMultiEnabled]="false"
          [selectionVisible]="true"
          [interactionMode]="'selection'"
        >
          <elder-data-toolbar
            *elderTableToolbar
            class="pt-md"
            [canMore]="false"
            [canAdd]="true"
            [canRemove]="true"
            (requestNew)="onNewSkillSet($event)"
            (requestRemove)="onRemoveSkillSets($event)"
          >
            <ng-template [elderToolbarContent]="'left'">
              <mat-form-field>
                <mat-label>{{ 'skillSets.add' | translate }}</mat-label>
                <elder-select
                  name="addSkillSet"
                  placeholder="{{ 'skillSets.add' | translate }}"
                  [data]="addableSkillSetSpecs()"
                  [displayProperty]="'name'"
                  (valueChange)="onNewSkillSet($event)"
                  [value]="dummyValue"
                >
                </elder-select>
              </mat-form-field>
            </ng-template>
          </elder-data-toolbar>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>{{ 'context.description' | translate }}</th>
            <td mat-cell *matCellDef="let skillSet">{{ skillSet.description }}</td>
          </ng-container>
          <ng-container matColumnDef="skillSetSpecId">
            <th mat-header-cell *matHeaderCellDef>{{ 'context.specification' | translate }}</th>
            <td mat-cell *matCellDef="let skillSet">
              @if (!!skillSet.spec) {
                <span>{{ skillSet.spec?.name }} </span>
              } @else {
                <div class="layout-col">
                  <span class="error">{{ 'skillSets.spec.missingSpec' | translate }}</span>
                  <span class="error" class="mat-caption">{{ skillSet?.skillSetSpecId }}</span>
                </div>
              }
            </td>
          </ng-container>
        </elder-table>
      </elder-pane-content>
    </elder-pane>
    <app-skill-set-detail class="flex" [skillSet]="selectedSkillSet()"> </app-skill-set-detail>
  </elder-basic-pane-layout>
}
